const constants = {
  FILTERS: {
    list: 'list',
    reportsProgressMilestone: 'reports-progress-milestone',
    project: 'project',
    sharedGantt: 'sharedGantt',
    sharedBoard: 'sharedBoard',
    multiview: 'multiview',
    userLogs: 'user-logs',
    timeloglist: 'timeloglist',
    costslist: 'costslist',
    calendarview: 'calendarview',
    boardview: 'boardview',
    history: 'history',
    workload: 'workload',
    export: 'export',
    reportsProgressStatuses: 'reports-progress-statuses',
    reportsProgressSchedule: 'reports-progress-schedule',
    reportsProgressPortfolio: 'reports-progress-portfolio',
    reportsProgressMonth: 'reports-progress-month',
    reportsBudgetProject: 'reports-budget-project',
    reportsBudgetMonth: 'reports-budget-month',
    reportsTimeProject: 'reports-time-project',
    reportsTimeMonth: 'reports-time-month',
  },
  EMPTY_PROPERTIES: {
    gantt_id: '',
    portfolio_id: '',
    type: '',
    status: '',
    assignee: '',
    priority: '',
    reporter: '',
    startDate: '',
    rangeDate: '',
    endDate: '',
    creationDate: '',
    color: '',
    text: '',
    task_name: '',
    cost_range: '',
    overdue: false,
    comment: '',
    resource_id: '',
    date: '',
    time: '',
    owner_id: '',
    project_status: '',
  },
  PROPERTY: {
    gantt_id: 'gantt_id',
    portfolio_id: 'portfolio_id',
    text: 'text',
    task_name: 'task_name',
    cost_range: 'cost_range',
    type: 'type',
    date: 'date',
    resource_id: 'resource_id',
    assignee: 'assignee',
    status: 'status',
    priority: 'priority',
    color: 'color',
    rangeDate: 'rangeDate',
    startDate: 'startDate',
    endDate: 'endDate',
    creationDate: 'creationDate',
    overdue: 'overdue',
    comment: 'comment',
    time: 'time',
    reporter: 'reporter',
    event: 'event',
    owner_id: 'owner_id',
    project_status: 'project_status',
  },
  STATUS_OPTIONS: [
    {
      id: '1',
      value: __('filter_status_open'),
      icon: {
        name: 'status-2',
        type: 'bold',
        size: 20,
        color: '#9b9b9b',
      },
    },
    {
      id: '2',
      value: __('filter_status_in_progress'),
      icon: {
        name: 'status-2',
        type: 'bold',
        size: 20,
        color: '#ff9921',
      },
    },
    {
      id: '3',
      value: __('filter_status_done'),
      icon: {
        name: 'status-2',
        type: 'bold',
        size: 20,
        color: '#55BED4',
      },
    },
    {
      id: '4',
      value: __('filter_status_closed'),
      icon: {
        name: 'status-2',
        type: 'bold',
        size: 20,
        color: '#14bb4c',
      },
    },
  ],
  PRIORITY_OPTIONS: [
    {
      id: '5',
      value: __('filter_priority_highest'),
      icon: {
        name: 'priority',
        type: 'bold',
        size: 20,
        color: '#DD3636',
      },
    },
    {
      id: '6',
      value: __('filter_priority_high'),
      icon: {
        name: 'priority',
        type: 'bold',
        size: 20,
        color: '#FFC266',
      },
    },
    {
      id: '7',
      value: __('filter_priority_medium'),
      icon: {
        name: 'priority',
        type: 'bold',
        size: 20,
        color: '#81C784',
      },
    },
    {
      id: '8',
      value: __('filter_priority_low'),
      icon: {
        name: 'priority-2',
        type: 'bold',
        size: 20,
        color: '#999999',
      },
    },
    {
      id: '9',
      value: __('filter_priority_lowest'),
      icon: {
        name: 'priority-2',
        type: 'bold',
        size: 20,
        color: '#CCCCCC',
      },
    },
  ],
  TYPE_OPTIONS: [
    {
      id: 'task',
      value: __('filter_task_type_task'),
      icon: {
        name: 'task',
        type: 'regular',
        size: 24,
        color: '#B2B2B2',
      },
    },
    {
      id: 'milestone',
      value: __('filter_task_type_milestone'),
      icon: {
        name: 'milestone',
        type: 'regular',
        size: 24,
        color: '#B2B2B2',
      },
    },
  ],
  EVENT_OPTIONS: [
    {
      icon: {
        name: 'task',
        type: 'regular',
        size: 24,
        color: '#191919',
      },
      eventType: 'task',
      id: 6,
      value: __('history_filter_event_type_task'),
    },
    {
      icon: {
        name: 'template',
        type: 'regular',
        size: 24,
        color: '#191919',
      },
      eventType: 'column',
      id: 12,
      value: __('history_filter_event_type_column'),
    },
    {
      icon: {
        name: 'priority',
        type: 'regular',
        size: 24,
        color: '#191919',
      },
      eventType: 'task-priority',
      id: 10,
      value: __('history_filter_event_type_task_priority'),
    },
    // {
    //   icon: icon_task,
    //   eventType: 'task-progress',
    //   id: 'byTaskProgress',
    //   value: __('history_filter_event_type_task_progress'),
    // },
    {
      icon: {
        name: 'status-1',
        type: 'regular',
        size: 24,
        color: '#191919',
      },
      eventType: 'task-status',
      id: 101,
      value: __('history_filter_event_type_task_status'),
    },
    {
      icon: {
        name: 'dragdrop',
        type: 'regular',
        size: 24,
        color: '#191919',
      },
      eventType: 'task-dnd',
      id: 8,
      value: __('history_filter_event_type_task_dnd'),
    },
    {
      icon: {
        name: 'assigned',
        type: 'regular',
        size: 24,
        color: '#191919',
      },
      eventType: 'resource',
      id: 5,
      value: __('history_filter_event_type_resource'),
    },
    {
      icon: {
        name: 'project',
        type: 'regular',
        size: 24,
        color: '#191919',
      },
      eventType: 'project-settings',
      id: 4,
      value: __('history_filter_event_type_project'),
    },
    {
      icon: {
        name: 'calendar',
        type: 'regular',
        size: 24,
        color: '#191919',
      },
      eventType: 'custom-day',
      id: 2,
      value: __('history_filter_event_type_custom_day'),
    },
    {
      icon: {
        name: 'project_name',
        type: 'regular',
        size: 24,
        color: '#191919',
      },
      eventType: 'dependency',
      id: 3,
      value: __('history_filter_event_type_dependency'),
    },
    {
      icon: {
        name: 'paste',
        type: 'regular',
        size: 24,
        color: '#191919',
      },
      eventType: 'copy',
      id: 11,
      value: __('history_filter_event_type_copy'),
    },
    {
      icon: {
        name: 'checklist',
        type: 'regular',
        size: 24,
        color: '#191919',
      },
      eventType: 'masschange',
      id: 15,
      value: __('history_filter_event_type_masschange'),
    },
    {
      icon: {
        name: 'cascade-sorting',
        type: 'regular',
        size: 24,
        color: '#191919',
      },
      eventType: 'cascadesort',
      id: 16,
      value: __('history_filter_event_type_cascadesort'),
    },
    {
      icon: {
        name: 'convertation',
        type: 'regular',
        size: 24,
        color: '#191919',
      },
      eventType: 'resource-convert',
      id: 17,
      value: __('history_filter_event_type_resource_convert'),
    },
  ],
};

export default constants;
